import { takeLatest, call, put } from 'redux-saga/effects'
import courseProgress from 'api/courses/CourseProgress'
import * as fromActions from '../../actions/courses.action'

async function getCourseProgress(courseId: number) {
  return await courseProgress(courseId)
}

function* courseProgressEffectSaga(action: any) {
  try {
    const { data } = yield call(getCourseProgress, action.payload)
    const aux = data.map((row: any) => ({
      ...row,
      courseId: Number(action.payload),
    }))
    yield put(fromActions.Actions.coursesUserCourseProgressSuccess(aux))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* courseProgressWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_USER_COURSE_PROGRESS,
    courseProgressEffectSaga
  )
}
